import { LoadablePaint, type LoadableType } from '@confluence/loadable';

export const TeamsAppShortcutLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalItem-TeamsAppShortcut" */ './TeamsAppShortcutItem.tsx'
			)
		).TeamsAppShortcutItem,
});
